import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

var styles = {"container":"micromag-element-container-container"};

var propTypes = {
  containerRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.any
  })]),
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  style: PropTypes.shape({}),
  className: PropTypes.string,
  children: PropTypes.node
};
var defaultProps = {
  containerRef: null,
  className: null,
  style: null,
  children: null
};
function Container(_ref) {
  var containerRef = _ref.containerRef,
    width = _ref.width,
    height = _ref.height,
    style = _ref.style,
    className = _ref.className,
    children = _ref.children;
  var hasSize = width > 0 && height > 0;
  var containerStyle = hasSize ? _objectSpread({
    width: width,
    height: height
  }, style) : style;
  return /*#__PURE__*/React.createElement("div", {
    ref: containerRef,
    className: classNames([styles.container, _defineProperty({}, className, className !== null)]),
    style: containerStyle
  }, children);
}
Container.propTypes = propTypes;
Container.defaultProps = defaultProps;
var Container$1 = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Container, Object.assign({
    containerRef: ref
  }, props));
});

export { Container$1 as default };
